// react_frontend/src/Components/Router/ProjectRouter.js
import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import Master from "../Layouts/Master";
import MasterAdminDashboard from "../Modules/MasterAdminDashboard";
import Profile from "../Modules/profile";
import Error500 from "../Modules/Error500";
import Error404 from "../Modules/Error404";
import Error401 from "../Modules/Error401";

// === Category ===
import AddCategory from "../Modules/Category/AddCategory";
import CategoryList from "../Modules/Category/CategoryList";
import EditCategory from "../Modules/Category/EditCategory";

// === User Setting ===
import AddUser from "../Modules/UserSetting/AddUser";
import UserList from "../Modules/UserSetting/UserList";
import EditUser from "../Modules/UserSetting/EditUser";

// === Employee (UserSetting) ===
import AddEmployee from "../Modules/UserSetting/AddEmployee";
import EmployeeList from "../Modules/UserSetting/EmployeeList"; // ← Original
import EditEmployee from "../Modules/UserSetting/EditEmployee";

// === Salary ===
import AddSalary from "../Modules/UserSetting/AddSalary";
import SalaryList from "../Modules/UserSetting/SalaryList";
import EditSalary from "../Modules/UserSetting/EditSalary";

// === Product ===
import AddProduct from "../Modules/ProductSetting/AddProduct";
import ProductList from "../Modules/ProductSetting/ProductList";
import EditProduct from "../Modules/ProductSetting/EditProduct";

// === Item ===
import AddItem from "../Modules/ItemSetting/AddItem";
import ItemList from "../Modules/ItemSetting/ItemList";
import EditItem from "../Modules/ItemSetting/EditItem";

// === Purchase ===
import AddPurchase from "../Modules/PurchaseSetting/AddPurchase";
import PurchaseList from "../Modules/PurchaseSetting/PurchaseList";
import EditPurchase from "../Modules/PurchaseSetting/EditPurchase";
import StockOut from "../Modules/PurchaseSetting/StockOut";
import StockList from "../Modules/PurchaseSetting/StockList";
import StockOutList from "../Modules/PurchaseSetting/StockOutList";
import TodayJs from "../Modules/PurchaseSetting/Today";
import StockReturn from "../Modules/PurchaseSetting/StockReturn";

// === Billing ===
import AddBilling from "../Modules/Billing/AddBilling";
import BillingList from "../Modules/Billing/BillingList";
import Report from "../Modules/Report";
import CustomerList from "../Modules/Billing/Customers";
import AddCustomer from "../Modules/Billing/AddCustomer";
import EditCustomer from "../Modules/Billing/EditCustomer";

// === Company & Print ===
import CompanySetting from "../Modules/CompanySetting";
import { PrintReceipt } from "../Modules/PrintReceipt";
import ActivityLogTable from "../Modules/UserSetting/ActivityLog";

// === Protected Route ===
import ProtectedRoute from "./ProtectedRoute";

// === HR MODULES (with ALIASES to avoid conflicts) ===
import HrDashboard from "../Modules/HR/HrDashboard";
import HrEmployeeList from "../Modules/HR/EmployeeList";           // ← Alias
import HrEmployeeProfile from "../Modules/HR/EmployeeProfile";     // ← Alias
import HrAttendancePunch from "../Modules/HR/AttendancePunch";     // ← Alias
import HrAttendanceSummary from "../Modules/HR/AttendanceSummary"; // ← Alias
import HrLeaveApply from "../Modules/HR/LeaveApply";               // ← Alias
import HrLeaveApproval from "../Modules/HR/LeaveApproval";         // ← Alias
import HrPayrollGenerate from "../Modules/HR/PayrollGenerate";     // ← Alias
import HrPayslipViewer from "../Modules/HR/PayslipViewer";         // ← Alias
import HrAssetManager from "../Modules/HR/AssetManager";           // ← Alias
import HrExpenseClaim from "../Modules/HR/ExpenseClaim";           // ← Alias
import HrRosterScheduler from "../Modules/HR/RosterScheduler";     // ← Alias
import HrDocumentManager from "../Modules/HR/DocumentManager";     // ← Alias
import HrLetterGenerator from "../Modules/HR/LetterGenerator";     // ← Alias
import HrRecruitmentPipeline from "../Modules/HR/RecruitmentPipeline"; // ← Alias
import HrPerformanceAppraisal from "../Modules/HR/PerformanceAppraisal"; // ← Alias
import HrChatAI from "../Modules/HR/HrChatAI";                     // ← Alias
import EmployeeDashboard from "../Modules/HR/EmployeeDashboard";
import RequisitionForm from "../Modules/HR/RequisitionForm";
import RequisitionApproval from "../Modules/HR/RequisitionApproval";
import MyRequests from "../Modules/HR/MyRequests";
import SalaryIncrement from "../Modules/HR/SalaryIncrement";
import ChartOfAccounts from "../Modules/Accounting/ChartOfAccounts";
import JournalEntries from "../Modules/Accounting/JournalEntries";
import TrialBalance from "../Modules/Accounting/TrialBalance";
import ProfitLoss from "../Modules/Accounting/ProfitLoss";
import BalanceSheet from "../Modules/Accounting/BalanceSheet";
import BankReconciliation from "../Modules/Accounting/BankReconciliation";
import ARAging from "../Modules/Accounting/ARAging";
import APAging from "../Modules/Accounting/APAging";
import VATReport from "../Modules/Accounting/VATReport";
import Quotations from "../Modules/Sales/Quotations";
import Vendors from "../Modules/Purchase/Vendors";
import Warehouses from "../Modules/Inventory/Warehouses";
import PurchaseOrders from "../Modules/Purchase/PurchaseOrders";
import StockTransfers from "../Modules/Inventory/StockTransfers";
import PurchaseReturns from "../Modules/Purchase/PurchaseReturns";
import CreditDebitNotes from "../Modules/Billing/CreditDebitNotes";
import ProductBatches from "../Modules/Inventory/ProductBatches";
import ExchangeRates from "../Modules/CompanySetting/ExchangeRates";
import BOMList from "../Modules/Inventory/BOMList";
import WorkOrders from "../Modules/Inventory/WorkOrders";
import StaffDeployments from "../Modules/HR/StaffDeployments";
import EventManagement from "../Modules/HR/EventManagement";
import DamageLossManagement from "../Modules/Inventory/DamageLossManagement";
import ProjectList from "../Modules/HR/ProjectList";
import ProjectBoard from "../Modules/HR/ProjectBoard";
import MyTasks from "../Modules/HR/MyTasks";

import CrmDashboard from "../Modules/CRM/CrmDashboard";
import CrmLeads from "../Modules/CRM/CrmLeads";
import CrmDeals from "../Modules/CRM/CrmDeals";
import CrmActivities from "../Modules/CRM/CrmActivities";


const ProjectRouter = createBrowserRouter([
  {
    path: "/",
    element: <Master />,
    children: [
      { path: "/", element: <Navigate to="/dashboard" replace /> },

      // === Dashboard & Profile ===
      {
        path: "/dashboard",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <MasterAdminDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/profile",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <Profile />
          </ProtectedRoute>
        ),
      },

      // === Users ===
      {
        path: "/add_user",
        element: (
          <ProtectedRoute allowedRoles={[1]}>
            <AddUser />
          </ProtectedRoute>
        ),
      },
      {
        path: "/user_setting",
        element: (
          <ProtectedRoute allowedRoles={[1, 2]}>
            <UserList />
          </ProtectedRoute>
        ),
      },
      {
        path: "/edit_user/:id",
        element: (
          <ProtectedRoute allowedRoles={[1, 2]}>
            <EditUser />
          </ProtectedRoute>
        ),
      },
      {
        path: "/activity_log",
        element: (
          <ProtectedRoute allowedRoles={[1, 2]}>
            <ActivityLogTable />
          </ProtectedRoute>
        ),
      },

      // === Employees (UserSetting) ===
      {
        path: "/add_employee",
        element: (
          <ProtectedRoute allowedRoles={[1, 2]}>
            <AddEmployee />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/employees/add",
        element: (
          <ProtectedRoute allowedRoles={[1, 2]}>
            <AddEmployee />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "/employee_setting",
      //   element: (
      //     <ProtectedRoute allowedRoles={[1, 2]}>
      //       <EmployeeList /> {/* ← Original EmployeeList */}
      //     </ProtectedRoute>
      //   ),
      // },
      {
        path: "/edit_employee/:id",
        element: (
          <ProtectedRoute allowedRoles={[1, 2]}>
            <EditEmployee />
          </ProtectedRoute>
        ),
      },

      // === Salary ===
      {
        path: "/add_salary",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3]}>
            <AddSalary />
          </ProtectedRoute>
        ),
      },
      {
        path: "/salary_setting",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3]}>
            <SalaryList />
          </ProtectedRoute>
        ),
      },
      {
        path: "/edit_salary/:id",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3]}>
            <EditSalary />
          </ProtectedRoute>
        ),
      },

      // === HR MODULES (with can.hr permission) ===
      {
        path: "/hr",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <HrDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/my-requests",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <MyRequests />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/employee_dashboard/:id",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <EmployeeDashboard /> {/* ← Alias */}
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/employee-dashboard",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <EmployeeDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/employees",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <HrEmployeeList /> {/* ← Alias */}
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/employees/:id",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <HrEmployeeProfile />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/attendance",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <HrAttendancePunch />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/attendance/summary",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <HrAttendanceSummary />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/leave/apply",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <HrLeaveApply />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/leave/approval",
        element: (
          <ProtectedRoute allowedRoles={[1, 2]}>
            <HrLeaveApproval />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/payroll",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3]}>
            <HrPayrollGenerate />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/payslips",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <HrPayslipViewer />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/assets",
        element: (
          <ProtectedRoute allowedRoles={[1, 2]}>
            <HrAssetManager />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/expenses",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <HrExpenseClaim />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/roster",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <HrRosterScheduler />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/documents",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <HrDocumentManager />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/letters",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <HrLetterGenerator />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/recruitment",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <HrRecruitmentPipeline />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/performance",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <HrPerformanceAppraisal />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/ai-chat",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <HrChatAI />
          </ProtectedRoute>
        ),
      },

      {
        path: "/hr/requisition",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <RequisitionForm />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/requisition-approval",
        element: (
          <ProtectedRoute allowedRoles={[1, 2]}>
            <RequisitionApproval />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/salary-increment",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <SalaryIncrement />
          </ProtectedRoute>
        ),
      },

      {
        path: "/hr/projects",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3]}>
            <ProjectList />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/projects/:id",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3]}>
            <ProjectBoard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/hr/my-tasks",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3, 4]}>
            <MyTasks />
          </ProtectedRoute>
        ),
      },

      // === Category ===
      {
        path: "/add_category",
        element: (
          <ProtectedRoute allowedRoles={[1, 2]}>
            <AddCategory />
          </ProtectedRoute>
        ),
      },
      {
        path: "/category",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 4]}>
            <CategoryList />
          </ProtectedRoute>
        ),
      },
      {
        path: "/edit_category/:id",
        element: (
          <ProtectedRoute allowedRoles={[1, 2]}>
            <EditCategory />
          </ProtectedRoute>
        ),
      },

      // === Products ===
      {
        path: "/add_product",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 4]}>
            <AddProduct />
          </ProtectedRoute>
        ),
      },
      { path: "/product_list", element: <ProductList /> },
      {
        path: "/edit_product/:id",
        element: (
          <ProtectedRoute allowedRoles={[1, 2]}>
            <EditProduct />
          </ProtectedRoute>
        ),
      },

      // === Items ===
      {
        path: "/add_item",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 4]}>
            <AddItem />
          </ProtectedRoute>
        ),
      },
      {
        path: "/item_list",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 4]}>
            <ItemList />
          </ProtectedRoute>
        ),
      },
      {
        path: "/edit_item/:id",
        element: (
          <ProtectedRoute allowedRoles={[1, 2]}>
            <EditItem />
          </ProtectedRoute>
        ),
      },

      // === Purchases ===
      {
        path: "/add_purchase",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3]}>
            <AddPurchase />
          </ProtectedRoute>
        ),
      },
      {
        path: "/purchase_list",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3]}>
            <PurchaseList />
          </ProtectedRoute>
        ),
      },
      {
        path: "/edit_purchase/:id",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3]}>
            <EditPurchase />
          </ProtectedRoute>
        ),
      },
      {
        path: "/stock_out",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3]}>
            <StockOut />
          </ProtectedRoute>
        ),
      },
      {
        path: "/stock_out_list",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3]}>
            <StockOutList />
          </ProtectedRoute>
        ),
      },
      {
        path: "/stock_in",
        element: (
          <ProtectedRoute allowedRoles={[1, 2]}>
            <StockReturn />
          </ProtectedRoute>
        ),
      },
      {
        path: "/stock_list",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3]}>
            <StockList />
          </ProtectedRoute>
        ),
      },
      { path: "/today", element: <TodayJs /> },

      // === Billing ===
      { path: "/add_billing", element: <AddBilling /> },
      { path: "/billing_list", element: <BillingList /> },
      { path: "/last_bill", element: <AddBilling /> },
      { path: "/reports", element: <Report /> },

      // === Customers ===
      { path: "/customers", element: <CustomerList /> },
      { path: "/add_customer", element: <AddCustomer /> },
      { path: "/edit_customer/:id", element: <EditCustomer /> },

      {
        path: "/crm/dashboard",
        element: (<ProtectedRoute allowedRoles={[1, 2, 3]}><CrmDashboard /></ProtectedRoute>),
      },
      {
        path: "/crm/leads",
        element: (<ProtectedRoute allowedRoles={[1, 2, 3]}><CrmLeads /></ProtectedRoute>),
      },
      {
        path: "/crm/deals",
        element: (<ProtectedRoute allowedRoles={[1, 2, 3]}><CrmDeals /></ProtectedRoute>),
      },
      {
        path: "/crm/activities",
        element: (<ProtectedRoute allowedRoles={[1, 2, 3, 4]}><CrmActivities /></ProtectedRoute>),
      },

      // === Company Setting ===
      {
        path: "/company_setting",
        element: (
          <ProtectedRoute allowedRoles={[1]}>
            <CompanySetting />
          </ProtectedRoute>
        ),
      },

      // === Print ===
      { path: "/print-receipt", element: <PrintReceipt /> },

      {
        path: "/chart-of-accounts",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3]}>
            <ChartOfAccounts />
          </ProtectedRoute>
        ),
      },

      {
        path: "/journal-entries",
        element: (
          <ProtectedRoute allowedRoles={[1, 2, 3]}>
            <JournalEntries />
          </ProtectedRoute>
        ),
      },

      { path: "/damage-loss", element: <ProtectedRoute allowedRoles={[1, 2]}><DamageLossManagement /></ProtectedRoute> },
      { path: "/stock-transfers", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><StockTransfers /></ProtectedRoute> },
      { path: "/purchase-returns", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><PurchaseReturns /></ProtectedRoute> },
      { path: "/credit-debit-notes", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><CreditDebitNotes /></ProtectedRoute> },
      { path: "/product-batches", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><ProductBatches /></ProtectedRoute> },
      { path: "/warehouses", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><Warehouses /></ProtectedRoute> },
      { path: "/purchase-orders", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><PurchaseOrders /></ProtectedRoute> },
      { path: "/quotations", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><Quotations /></ProtectedRoute> },
      { path: "/vendors", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><Vendors /></ProtectedRoute> },
      { path: "/trial-balance", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><TrialBalance /></ProtectedRoute> },
      { path: "/profit-loss", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><ProfitLoss /></ProtectedRoute> },
      { path: "/balance-sheet", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><BalanceSheet /></ProtectedRoute> },
      { path: "/bank-reconciliation", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><BankReconciliation /></ProtectedRoute> },
      { path: "/ar-aging", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><ARAging /></ProtectedRoute> },
      { path: "/ap-aging", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><APAging /></ProtectedRoute> },
      { path: "/vat-report", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><VATReport /></ProtectedRoute> },
      { path: "/exchange-rates", element: <ProtectedRoute allowedRoles={[1]}><ExchangeRates /></ProtectedRoute> },
      { path: "/bom-list", element: <ProtectedRoute allowedRoles={[1, 2]}><BOMList /></ProtectedRoute> },
      { path: "/work-orders", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><WorkOrders /></ProtectedRoute> },
      { path: "/staff-deployments", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><StaffDeployments /></ProtectedRoute> },
      { path: "/event-management", element: <ProtectedRoute allowedRoles={[1, 2, 3]}><EventManagement /></ProtectedRoute> },

      // === Error Pages ===
      { path: "/error-500", element: <Error500 /> },
      { path: "/error-401", element: <Error401 /> },
      { path: "*", element: <Error404 /> },
    ],
  },
]);

export default ProjectRouter;